import { createAction } from 'redux-act';
//////////////////////////////////////////////////

export const getCurrentLocationRequest = createAction('getCurrentLocationRequest');
export const getLocationReferenceRequest = createAction('getLocationReferenceRequest');
export const updateLocationReferenceRequest = createAction('updateLocationReferenceRequest');
export const deleteLocationReferenceRequest = createAction('deleteLocationReferenceRequest');
export const createLocationReferenceRequest = createAction('createLocationReferenceRequest');
